import {Controller} from 'stimulus'
import {useClickOutside} from 'stimulus-use'
import {initializeSearchiq} from 'static/initializers/externals'
export default class extends Controller {
  static targets = ['searchForm', 'sectionsContainer', 'section', 'tab']

  connect() {
    if (this.hasSectionsContainerTarget) {
      useClickOutside(this, this.sectionsContainerTarget)
    }

    if (document.body.querySelector('#siq_search_results')) {
      initializeSearchiq()
    }
  }

  clickOutside() {
    this.hideAllSections()
  }

  openSearchForm() {
    this.searchFormTarget.classList.add('open-search')
    document.body.querySelector('#mobile-navigation').classList.add('hide')

    initializeSearchiq()
  }

  closeSearchForm() {
    this.searchFormTarget.classList.remove('open-search')
    document.body.querySelector('#mobile-navigation').classList.remove('hide')
  }

  hideAllSections() {
    this.sectionTargets.forEach((el) => {
      if (el.classList.contains('active')) {
        el.classList.remove('active')
        setTimeout(() => {
          const dropDown = el.querySelector('.static-header__nav-drop-down') ||
            el.querySelector('.static-header__small-drop-down')
          if (dropDown) {
            dropDown.classList.add('hide')
          }
        }, 500)
      } else {
        const dropDown = el.querySelector('.static-header__nav-drop-down') ||
          el.querySelector('.static-header__small-drop-down')
        if (dropDown) {
          dropDown.classList.add('hide')
        }
      }
    })
  }

  showThisSection({target}) {
    const activeSection = target.parentElement

    if (activeSection.classList.contains('active')) {
      // Closing the menu - remove active first, then hide dropdown after animation
      activeSection.classList.remove('active')
      setTimeout(() => {
        const dropDownEl = activeSection.querySelector('.static-header__nav-drop-down') ||
          activeSection.querySelector('.static-header__small-drop-down')
        if (dropDownEl) {
          dropDownEl.classList.add('hide')
        }
      }, 500) // Wait for animation to complete
      target.parentElement.classList.remove('active')
    } else {
      // Opening the menu - first close all other menus with animation
      this.sectionTargets.forEach((el) => {
        if (el.classList.contains('active')) {
          el.classList.remove('active')
          setTimeout(() => {
            const dropDown = el.querySelector('.static-header__nav-drop-down') ||
              el.querySelector('.static-header__small-drop-down')
            if (dropDown) {
              dropDown.classList.add('hide')
            }
          }, 500)
        } else {
          // For non-active sections, immediately hide
          const dropDown = el.querySelector('.static-header__nav-drop-down') ||
            el.querySelector('.static-header__small-drop-down')
          if (dropDown) {
            dropDown.classList.add('hide')
          }
        }
      })

      // Then open this menu - remove hide first, then add active with small delay for CSS transition
      const dropDownEl = activeSection.querySelector('.static-header__nav-drop-down') ||
        activeSection.querySelector('.static-header__small-drop-down')
      if (dropDownEl) {
        dropDownEl.classList.remove('hide')
      }
      setTimeout(() => {
        activeSection.classList.add('active')
      }, 10) // Small delay to trigger CSS transition
    }
  }

  showTabSection({target}) {
    this.tabTargets.forEach((el) => el.classList.remove('active'))
    target.parentElement.classList.toggle('active')
  }
}
